import { Spin, Flex } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { styled } from "styled-components"

const StyledSpin = styled(Spin)`
  .anticon {
    color: ${({ theme }) => theme.colors.primaryColors.gxAccentMedium};
  }
`

function LoadingMessage({ loading, message }: { loading: boolean; message: string }) {
  if (!loading) return null
  return (
    <Flex align="center" gap="small">
      <StyledSpin indicator={<LoadingOutlined spin />} />
      {message}
    </Flex>
  )
}

export { LoadingMessage }
